const cookieBot = {
    install: (app, options) => {
        app.provide('cookieBotOptions', options);
        requestAnimationFrame(() => {
            if (typeof app.config.globalProperties.$router === 'object') {
                app.config.globalProperties.$router.afterEach(() => {
                    if ('Cookiebot' in window) {
                        requestAnimationFrame(() => {
                            window.Cookiebot.runScripts();
                        });
                    }
                });
            }
        });
    },
};
export { cookieBot };
//# sourceMappingURL=plugin.js.map